<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">   
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <form [formGroup]="form" (ngSubmit)="onSubmitArrangerContractDateForm()">
            <span class="ui-float-label" style="margin-bottom: 10px; margin-top: 10px;">
                <label for="sign-date-input">{{ 'sign_contract_date_sign' | translate }}</label>
                <p-calendar id="sign-date-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" formControlName="contract_date_signment"  dateFormat="yy-mm-dd"></p-calendar>
            </span>          
    
            <div *ngIf="isEditing == false"> 
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="onEdit()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>          
            </div> 
            <div class="ui-g" *ngIf="isEditing == true">  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button pButton type="submit" [disabled]="!form.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>  
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="cancelForm()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>                 
            </div>
        </form>
    </div>
</div>